import React, { useState, useCallback } from 'react';
import BorisChatWidget from './BorisChatWidget';
import './EnhancedChatDashboard.css';

const EnhancedChatDashboard = () => {
  const [error, setError] = useState(null);
  const [isChatOpen, setIsChatOpen] = useState(false);

  const handleSessionCreated = useCallback((sessionId) => {
    setError(null);
    console.log('Session created:', sessionId);
  }, []);

  const handleMessageSent = useCallback((message, response) => {
    console.log('Message sent:', message);
    console.log('Bot response:', response);
  }, []);

  const toggleChat = () => {
    setIsChatOpen(!isChatOpen);
  };

  return (
    <div className="enhanced-chat-dashboard">
      {/* Error Display */}
      {error && (
        <div className="error-banner">
          <span>❌ {error}</span>
          <button onClick={() => setError(null)}>×</button>
        </div>
      )}

      {/* Floating Chat Widget Toggle Button */}
      <button 
        className={`chat-widget-toggle ${isChatOpen ? 'chat-open' : ''}`}
        onClick={toggleChat}
        title={isChatOpen ? 'Close Chat' : 'Open Chat'}
      >
        {isChatOpen ? '✕' : '💬'}
      </button>

      {/* Chat Widget - Positioned as floating widget */}
      {isChatOpen && (
        <div className="chat-widget-positioned">
          <BorisChatWidget
            userId={null} // Start with no user ID to trigger form
            autoStart={false}
            requireUserDetails={true} // Enable user details collection
            onSessionCreated={handleSessionCreated}
            onMessageSent={handleMessageSent}
          />
        </div>
      )}
    </div>
  );
};

export default EnhancedChatDashboard;